import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NextRouter, withRouter } from 'next/router'

import lang from 'lang'
import {
  changeMoodMeterInGroupFormField,
  resetMoodMeterInGroupFormData,
} from 'page-modules/mood-meter/in-group/actions'
import { urls } from 'common/routes'
import { replace } from 'common/utils'
import { AppState } from 'common/store/reducer'

const connector = connect(
  (state: AppState) => ({
    code: state.moodMeter.forms.ingroup.data.code,
    dirty: state.moodMeter.forms.ingroup.dirty,
  }),
  (dispatch) => ({
    resetMoodMeterInGroupFormData: () => dispatch(resetMoodMeterInGroupFormData()),
    changeFormField: (key: string, value: string) =>
      dispatch(changeMoodMeterInGroupFormField(key, value)),
  }),
)

type Props = ConnectedProps<typeof connector> & {
  router: NextRouter
  hasCode?: boolean
}

class InGroupForm extends React.Component<Props> {
  createFieldHandler(fieldName: string) {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      if (this.props.changeFormField) {
        this.props.changeFormField(fieldName, e.target.value)
      }
    }
  }

  submitMoodMeterInGroupPlotHandler() {
    return (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      this.props.resetMoodMeterInGroupFormData()
      window.location.href = urls.moodMeterPlotInGroup(this.props.code)
    }
  }

  render() {
    return (
      <>
        <div className="hero-section">
          <div className="grid-container">
            <div className="grid-x grid-padding-x">
              <div className="small-12 medium-12 large-8 cell">
                <h1>{lang.page.moodMeter.groupPlot}</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="grid-container margin-top-1">
          <div className="grid-x grid-padding-x">
            <div className="small-12 medium-8 large-6 cell">
              <h5>{lang.page.moodMeter.typeGroupCode}</h5>
              <form>
                <input
                  type="text"
                  onChange={this.createFieldHandler('code')}
                  required
                  pattern="alpha_numeric"
                  tabIndex={0}
                />
                {this.props.hasCode ? (
                  <p className="form-error is-visible">
                    {replace(lang.page.moodMeter.invalidCode, [
                      this.props.router.query?.shortCode as string,
                    ])}
                  </p>
                ) : null}
                <button
                  type="submit"
                  className="button submit save"
                  onClick={this.submitMoodMeterInGroupPlotHandler()}
                  disabled={!this.props.dirty}>
                  {lang.submitButton}
                </button>
              </form>
            </div>
          </div>
        </div>
      </>
    )
  }
}

const ConnectedInGroupForm = connector(InGroupForm)
export default withRouter(ConnectedInGroupForm) as React.ComponentType<{ hasCode?: boolean }>
